import { useTranslation } from 'react-i18next';

export default function AboutMission() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Tag */}
        <div className="text-center mb-14">
          <span className="inline-block bg-sky-50 text-sky-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4">
            {t('about_mission_tag')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">{t('about_mission_title')}</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
          {/* Mission Card */}
          <div className="relative rounded-2xl overflow-hidden group">
            <div className="w-full h-72 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/88c27b8514441720f7d7e0010c83194a.jpg"
                alt="Our Mission"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="bg-gradient-to-br from-sky-50 to-white border border-sky-100 p-8 rounded-b-2xl">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sky-100">
                  <i className="ri-focus-line text-sky-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900">{t('about_mission_label')}</h3>
              </div>
              <p className="text-slate-600 leading-relaxed text-sm">{t('about_mission_text')}</p>
            </div>
          </div>

          {/* Vision + Story stacked */}
          <div className="flex flex-col gap-6">
            {/* Vision */}
            <div className="relative rounded-2xl overflow-hidden group flex-1">
              <div className="w-full h-44 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20beautiful%20home%20energy%20efficient%20windows%20suburban%20Georgia%20neighborhood%20blue%20sky%20green%20lawn%20clean%20architecture%20future%20growth%20vision&width=800&height=400&seq=about-vision-img-1&orientation=landscape"
                  alt="Our Vision"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-100 p-6 rounded-b-2xl">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-slate-100">
                    <i className="ri-eye-line text-slate-600 text-lg"></i>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900">{t('about_vision_label')}</h3>
                </div>
                <p className="text-slate-600 leading-relaxed text-sm">{t('about_vision_text')}</p>
              </div>
            </div>

            {/* Story */}
            <div className="bg-[#0F2A50] rounded-2xl p-8 flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sky-500/20">
                  <i className="ri-history-line text-sky-400 text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-white">{t('about_story_label')}</h3>
              </div>
              <p className="text-white/75 leading-relaxed text-sm">{t('about_story_text')}</p>
              <div className="mt-6 flex items-center gap-6 flex-wrap">
                <div className="flex items-center gap-2 text-sky-400 text-xs font-semibold">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  Lawrenceville, GA
                </div>
                <div className="flex items-center gap-2 text-sky-400 text-xs font-semibold">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shield-check-line text-sm"></i>
                  </div>
                  Licensed &amp; Insured
                </div>
                <div className="flex items-center gap-2 text-sky-400 text-xs font-semibold">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-line text-sm"></i>
                  </div>
                  5-Star Rated
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
